import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarcodePrintComponent } from './barcode-print.component';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [BarcodePrintComponent],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class BarcodePrintModule { }
